import type { PlayerHighlight, PlayerWarning } from '@hooks/useStrategyStats';
import type React from 'react';

/**
 * Player warning/highlight display with gradient styling
 */
export function PlayerBadge({
  player,
  type,
}: {
  player: PlayerWarning | PlayerHighlight;
  type: 'warning' | 'highlight';
}): React.ReactElement {
  const isWarning = type === 'warning';

  return (
    <div
      className={`flex items-center justify-between px-2.5 py-1.5 rounded-lg border ${
        isWarning
          ? 'bg-gradient-to-r from-orange-500/20 to-amber-400/15 border-theme-warning/30'
          : 'bg-gradient-to-r from-theme-success/20 to-emerald-400/15 border-theme-success/30'
      }`}
    >
      <div className="flex items-center gap-2">
        <span className={`text-sm ${isWarning ? 'text-theme-warning' : 'text-theme-success'}`}>
          {isWarning ? '⚠️' : '⭐'}
        </span>
        <span className="text-xs text-theme-text font-medium">{player.player}</span>
      </div>
      <div className="flex items-center gap-2">
        <span
          className={`text-xs font-bold ${isWarning ? 'text-theme-warning' : 'text-theme-success'}`}
        >
          {(player.hitRate * 100).toFixed(0)}%
        </span>
        <span className="text-[10px] text-theme-text-tertiary">({player.totalBets})</span>
      </div>
    </div>
  );
}
